<template>
  <div style="overflow-x:auto;overflow-y:hidden;height:88px">
    <div class="root-chart">
      <ul>
        <li v-for="sessionCount in sessionCountList" :key="sessionCount.servicePort" :style="[{ width: widthPercent + '%' }, { 'min-width': '110px' }, { 'text-align': 'center'}, { cursor: 'auto'}]">
          <span>{{sessionCount.label}}</span>
          <span class="status">
            {{ isNil(sessionCount['MAJORSESSIONSTAT/SESSION_CONNECTION_COUNT']) ? '-' : sessionCount['MAJORSESSIONSTAT/SESSION_CONNECTION_COUNT'] }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty } from 'lodash';
import ServerTableAPI from '@/api/performance/server/info-table';

export default {
  name: 'WSessionCountBar',
  props: {
    active: {
      type: Boolean,
      defulat: false,
    },
  },
  data() {
    return {
      sessionCountList: [
        {
          label: 'Total',
          count: '-',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
    widthPercent() {
      if (isEmpty(this.sessionCountList)) {
        return 100;
      }
      return (1 / this.sessionCountList.length) * 100;
    },
  },
  watch: {
    selectedNode: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
    active: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
  },
  methods: {
    isNil,
    loadData() {
      if (this.active) {
        const params = {
          objId: this.selectedNode.obj.objId,
        };
        ServerTableAPI.getMajorSessionCountByService(params).then((response) => {
          if (response.data.success) {
            const tempList = response.data.data;
            if (tempList.length > 0) {
              this.sessionCountList = tempList;
            } else {
              this.sessionCountList = [
                {
                  label: 'Total',
                  count: '-',
                },
              ];
            }
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/server/components/table/components/SessionCountBar.vue